'use strict';

export function executeRecaptcha(reCaptchaKey, onSuccess, onFailed) {
    if (typeof grecaptcha === 'object' && reCaptchaKey !== '') {
        grecaptcha.ready(function () {
            grecaptcha.execute(reCaptchaKey, {
                action: 'form'
            }).then(function (token) {
                onSuccess(token);
            }).catch(error => onFailed(error.message));
        });
    }
    else
    {
        onFailed('Le script reCAPTCHA n’a pas pu être&nbsp;chargé.');
    }
}
